import appGlobalScript from '/home/vsts/work/1/s/packages/apps/cms-components/src/global/app.ts';
export const globalScripts = appGlobalScript;
